import {
  Component,
  computed,
  effect,
  HostListener,
  inject,
  OnInit,
  signal,
} from "@angular/core";
import { IonicModule, ModalController } from "@ionic/angular";
import { RouterModule, Router } from "@angular/router";
import { AuthService } from "src/app/Services/auth/auth.service";
import { SidebarComponent } from "../sidebar/sidebar.component";
import { Platform, ToastController } from "@ionic/angular/standalone";
import { StateService } from "src/app/Services/state/state.service";
import { LanguageComponentComponent } from "../language-component/language-component.component";
import { TranslateService } from "@ngx-translate/core";
import { LoginUser } from "src/app/models/user.model";

@Component({
  selector: "app-appbar",
  templateUrl: "./appbar.component.html",
  styleUrls: ["./appbar.component.scss"],
  standalone: true,
  imports: [
    IonicModule,
    RouterModule,
    SidebarComponent,
    LanguageComponentComponent,
  ],
})
export class AppbarComponent implements OnInit {
  router = inject(Router);
  authService = inject(AuthService);
  modalCtrl = inject(ModalController);
  toastController = inject(ToastController);
  stateService = inject(StateService);
  translate = inject(TranslateService);
  platform = inject(Platform);

  isLandscape = signal(this.platform.isLandscape());

  constructor() {
    this.updateOrientation();

    window.addEventListener("resize", () => {
      this.updateOrientation();
    });

    effect(
      () => {
        if (!this.isMobile() && this.isModalOpen()) {
          this.closeSidebar();
        }
      },
      { allowSignalWrites: true }
    );
    // console.log("app is restarting");
    // effect(() => {
    //   const user = this.stateService.userInfo();
    //   if (user?.twixor_enabled) {
    //     this.stateService.addChatRoute(user);
    //   }
    // });
  }

  logoUrl = "";
  user = computed<{ enableTwixor: boolean; avatar: string } | null>(() => {
    const userInfo = this.stateService.getUserInfo() as LoginUser;
    if (userInfo) {
      return {
        enableTwixor: userInfo.twixor_enabled as boolean,
        avatar: userInfo.avatar as string,
      };
    }
    return null;
  });

  screenWidth = signal(window.innerWidth);
  isMobile = computed(() => (this.screenWidth() <= 1023 ? true : false));
  isModalOpen = signal<any>(null);

  ngOnInit() {}

  closeSidebar() {
    this.modalCtrl.dismiss();
    this.isModalOpen.update(() => null);
  }

  applyBranding(branding: any) {
    if (branding.logoUrl && branding.logoUrl !== "") {
      this.setBackgroundImage(
        ".appbar .logo",
        "/assets/images/medplusOfficialLogo.png"
      );
    } else {
      setTimeout(() => {
        this.setBackgroundImage(
          ".appbar .logo",
          "/assets/images/medplusOfficialLogo.png"
        );
      }, 100);
    }
  }

  setBackgroundImage(selector: string, imageUrl: string) {
    const element = document.querySelector(selector) as HTMLElement;
    if (element) {
      element.style.backgroundImage = `url(${imageUrl})`;
    } else {
      console.log("element not found");
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.screenWidth.set(event.target.innerWidth);
  }

  async openMenu() {
    const modal = await this.modalCtrl.create({
      component: SidebarComponent,
      backdropDismiss: true,
      canDismiss: true,
      cssClass: "sideBar-modal",
      animated: true,
      showBackdrop: true,
    });
    this.isModalOpen.set(modal);
    modal.present();
  }

  logout() {
    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(["/login"], { replaceUrl: true });
      },
      error: (err) => {
        console.error("Logout failed:", err);
      },
    });
  }
  showMaintananceMsg() {
    console.log("twixor disabled");
    this.translate
      .get("chatDisabledMsgText")
      .subscribe((translatedMessage: string) => {
        this.presentToast("middle", translatedMessage);
      });
  }
  async presentToast(position: "top" | "middle" | "bottom", message: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      position: position,
      color: "medium",
      animated: true,
      swipeGesture: "vertical",
    });
    await toast.present();
  }

  private updateOrientation() {
    const width = this.platform.width();
    const height = this.platform.height();
    this.isLandscape.set(width > height);
  }
}
